import { body, isMobileMq } from './utils.js';

export function siteHeaderInit () {
	const mobileToggle = document.querySelector('.site-header__navigation-toggle');
	const searchToggle = document.querySelector('.site-header__search-toggle');
	const mobileMenu = document.querySelector('.site-header__mobile-menu');

	if ( ! mobileToggle || ! mobileMenu ) {
		return;
	} else {
		// Mobile Menu triggered to open.
		mobileToggle.addEventListener('click', function (e) {
			if ( isMobileMq ) {
				e.preventDefault();
				mobileMenu.classList.toggle('mobile-menu--open');
				body.classList.toggle('mobile-menu-open');
				window.scrollTo(0, 0);
			}
		});
	}

	if ( ! searchToggle ) {
		return;
	} else {
		searchToggle.addEventListener('click', function (e) {
			e.preventDefault();
			body.classList.toggle('search-open');
			window.scrollTo(0, 0);
		});
	}
};
